<template>
  <AppContainer
    class="pt-32 md:pt-40">
    <div
      class="flex w-full flex-col items-center justify-between gap-10 md:gap-20 xl:flex-row">
      <div class="flex-1">
        <NuxtImg
          loading="lazy"
          src="/images/press.svg"
          class="w-full"
          alt="Press Release" />
      </div>
      <div class="flex w-full max-w-xl shrink-0 flex-col items-center gap-9 xl:w-176 xl:max-w-full xl:items-start">
        <h2 class="heading-primary text-center text-3xl font-bold md:text-[40px] md:leading-tight xl:text-left">
          Introducing <em>Certificates.dev</em> &middot; Empowering Developers Worldwide
        </h2>
        <p class="text-center text-sm text-eerie-black md:text-base xl:text-left dark:text-white">
          Vue School has been at the forefront of online developer education since its inception in 2016, providing Vue.js enthusiasts of all skill levels with the world's first (and largest) dedicated Vue.js training platform. Over the years we’ve collaborated with the greatest industry experts to create hundreds of lessons, courses, workshops, and tutorials, events and upskilled more than 700,000 developers.
        </p>
        <NuxtLink
          to="/press-release"
          target="_blank"
          class="btn-primary w-full px-8 py-4 xl:w-fit">
          Read the Press Release
        </NuxtLink>
      </div>
    </div>
  </AppContainer>
</template>
